import { EPostStatus } from '@constants';
import { IPost } from '@sdk/contracts';
import { Button, Flex } from 'antd';
import { useTranslation } from 'react-i18next';

import { SubmitButtonsWrapper } from '../../PostForm.styles';

type Props = {
  post?: IPost;
  isPending: boolean;
  onSaveAsDraft: () => void;
  onSchedule: () => void;
  onPublishNow: () => void;
  onSaveChanges: () => void;
  canSaveAsDraft: boolean;
};

export const FormFooter: React.FC<Props> = ({
  post,
  isPending,
  onSaveAsDraft,
  onSchedule,
  onPublishNow,
  onSaveChanges,
  canSaveAsDraft
}) => {
  const { t } = useTranslation('CommonDashboardTranslations');

  const isEditingScheduledPost = post?.status === EPostStatus.SCHEDULED;

  return (
    <SubmitButtonsWrapper>
      <Button
        type="text"
        loading={isPending}
        onClick={onSaveAsDraft}
        style={{ visibility: canSaveAsDraft ? 'visible' : 'hidden' }}>
        {t('SAVE_DRAFT')}
      </Button>

      <Flex gap={8}>
        {isEditingScheduledPost ? (
          <>
            <Button loading={isPending} onClick={onPublishNow}>
              {t('PUBLISH_NOW')}
            </Button>
            <Button loading={isPending} type="primary" onClick={onSaveChanges}>
              {t('SAVE_CHANGES')}
            </Button>
          </>
        ) : (
          <>
            <Button loading={isPending} onClick={onSchedule}>
              {t('SCHEDULE_POST')}
            </Button>
            <Button loading={isPending} type="primary" onClick={onPublishNow}>
              {t('PUBLISH_NOW')}
            </Button>
          </>
        )}
      </Flex>
    </SubmitButtonsWrapper>
  );
};
